import { Button } from '@fullscreendigital/carrefour-dex-fe'
import { Grid } from '@mui/material'
import { Modal } from 'components/core-ui/Modal'
import s from 'components/core-ui/Modal/Modal.modules.scss'
import React from "react";

const WarningModal: React.FC<WarningModalProps> = ({ isModalOpen, closeModal, confirm, hubName }) => {
  return (
    <Modal isModalOpen={isModalOpen} closeModal={closeModal}>
      <Grid container spacing={4} style={{ marginBottom: '40px' }}>
        <Grid xs={12} item style={{ textAlign: 'center' }}>
          Acest utilizator esta deja alocat pe hub {hubName}.
          Utilizatorul va fi sters de pe hub {hubName}. Continuati?
        </Grid>
      </Grid>
      <Grid xs={12} item className={s.modalButtons}>
        <Button variant="outlined" label="Nu" onClick={closeModal} />
        <Button variant="contained" label="Da" onClick={confirm} />
      </Grid>
    </Modal>
  )
}

export default WarningModal
